// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_updateAgentMarketingProfileAboutSection(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["AgentMarketingProfileAboutSectionUpdated"]);
}

let variablesConverter = {"updateAgentMarketingProfileAboutSectionInput":{"specialties":{"b":""},"bio":{"b":""}},"__root":{"input":{"r":"updateAgentMarketingProfileAboutSectionInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"updateAgentMarketingProfileAboutSection_AgentMarketingProfileAboutSectionUpdated_marketingProfile":{"f":""},"updateAgentMarketingProfileAboutSection":{"u":"response_updateAgentMarketingProfileAboutSection"}}};

let wrapResponseConverterMap = {
  response_updateAgentMarketingProfileAboutSection: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"updateAgentMarketingProfileAboutSection_AgentMarketingProfileAboutSectionUpdated_marketingProfile":{"f":""},"updateAgentMarketingProfileAboutSection":{"u":"response_updateAgentMarketingProfileAboutSection"}}};

let responseConverterMap = {
  response_updateAgentMarketingProfileAboutSection: unwrap_response_updateAgentMarketingProfileAboutSection
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentMarketingProfileAboutSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentMarketingProfileAboutSection",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AgentMarketingProfileAboutSettings_form_agentMarketingProfile"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AgentMarketingProfileAboutSectionUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentMarketingProfileAboutSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentMarketingProfileAboutSection",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bio",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "specialties",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publicUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AgentMarketingProfileAboutSectionUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a86d9cd7ae1989eedd7a8e811293391f",
    "id": null,
    "metadata": {},
    "name": "AgentMarketingProfileAboutSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation AgentMarketingProfileAboutSettingsMutation(\n  $input: UpdateAgentMarketingProfileAboutSectionInput!\n) {\n  updateAgentMarketingProfileAboutSection(input: $input) {\n    __typename\n    ... on AgentMarketingProfileAboutSectionUpdated {\n      marketingProfile {\n        ...AgentMarketingProfileAboutSettings_form_agentMarketingProfile\n        nodeId\n      }\n    }\n  }\n}\n\nfragment AgentMarketingProfileAboutSettings_form_agentMarketingProfile on AgentMarketingProfile {\n  bio\n  specialties\n  publicUrl\n}\n"
  }
};
})());

let wrap_response_updateAgentMarketingProfileAboutSection = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateAgentMarketingProfileAboutSection = unwrap_response_updateAgentMarketingProfileAboutSection;
exports.wrap_response_updateAgentMarketingProfileAboutSection = wrap_response_updateAgentMarketingProfileAboutSection;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
